import { createModel } from "hox";
import {IUserSearch,IUserParams,IUserInsert,IUserUpdata,IUserDisable,IUserDetail} from "./userTypes"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import React, { useState } from "react"
import { filterArrId, Optios, transPgToPagination, findOption } from "../../../utils/utils"
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { globalPrompt } from "../../../components2/YhMessage"
import { userService } from "./userService"
import useMdmModel from "../../../model/mdmModel"
import moment,{Moment} from "moment";

export const useUserModel = createModel(function () {
    const { mdmOrgan } = useMdmModel();

    const initSearchParams: IUserParams = {}
    const initDataSource: IUserDetail[] = []
    const initAddParam: IUserInsert = {enable:true,branch:"main"}
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IUserParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<IUserDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    //表格选中行key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<IUserDetail[]>([]);
    //新增参数
    const [addParam, setAddParam] = useState<IUserInsert>(initAddParam);
    //
    const [userTypeList, setUserTypeList] = useState<Optios[]>([])
    const upDataSearchParam = (upDataParam: IUserParams) => {
        console.log(upDataParam)
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = async () => {
        await setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        await loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: IUserParams) => {
        const searchParams = data ?? searchParam
        console.log(searchParam, data)
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await userService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        const newRecords = records.map((item,index)=>{
            return {
                ...item,
                birthday:moment(item.birthday)
            }
        })
        setDataSource(newRecords)
    }
    const updataAddParam = (updateParam: IUserInsert) => {
        let newUpdateParam = updateParam
        if (Object.keys(updateParam)[0] === "userTypeCode") {
            let findItem = findOption(updateParam.userTypeCode as string, userTypeList)
            newUpdateParam = { ...updateParam, userTypeName: findItem?.label }
        }
        console.log(newUpdateParam)
        setAddParam({ ...addParam, ...newUpdateParam })
    }
    const updataEditParam = (updateParam: IUserDetail) => {
        let newUpdateParam = updateParam
        console.log(newUpdateParam)
        if (Object.keys(updateParam)[0] === "userTypeCode") {
            let findItem = findOption(updateParam.userTypeCode as string, userTypeList)
            newUpdateParam = { ...updateParam, userTypeName: findItem?.label as string }
        }
        console.log(selectedRow)
        setSelectedRow([{ ...selectedRow[0], ...newUpdateParam }])
    }
    const insertDetail = async (params: IUserInsert) => {
        const param = {
            ...addParam,
            sourceApp: "mdm",
            enable: addParam.enable ? 1 : 0,
            birthday:addParam.birthday?.format('YYYY-MM-DD HH:mm:ss') as any
        }
        const { retData, retMsg } = await userService.insert(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData 
    }
    const updataDetail = async (params: IUserDetail) => {
        const param = {
            ...selectedRow[0],
            enable: selectedRow[0].enable ? 1 : 0,
            birthday:selectedRow[0].birthday?.format('YYYY-MM-DD HH:mm:ss') as any
        }
        const { retData, retMsg } = await userService.update(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData 
    }
    const cutDisabled = async (params: IUserDetail, checked: boolean) => {
        const param = {
            ...params,
            enable: checked ? 1 : 0,
            birthday:params.birthday?.format('YYYY-MM-DD HH:mm:ss') as any
        }
        const { retData, retMsg } = await userService.update(param)
        await globalPrompt("message", { type: "success", text: "修改完成" })
        await loadData()
    }
    return {
        searchParam,
        dataSource,
        page,
        selectedRow,
        selectedRowKeys,
        addParam,
        userTypeList,
        setSearchParam,
        setDataSource,
        setPage,
        setSelectedRowKeys,
        setSelectedRow,
        upDataSearchParam,
        resetSearchParam,
        loadData,
        setAddParam,
        updataAddParam,
        updataEditParam,
        insertDetail,
        updataDetail,
        cutDisabled,
        setUserTypeList
    }
});